import React, { Component } from "react";

import Header from "../../../components/Library/Header";
import Layout from "../../../components/Library/Layout";
import Sidebar from "../../../components/Library/Layout/Sidebar";
import Content from "../../../components/Library/Layout/Content";
import UpcomingEvents from "../UpcomingEvents";
import PassedEvents from "../PassedEvents";

import styles from "./Events.css";

class Events extends Component {
  render() {
    const header = <Header className={styles.events} text="Events" />;
    return (
      <Layout includeHeader={true} headerComponent={header}>
        <Sidebar/>
        <Content ariaLabel="Events">
          <UpcomingEvents />
          <PassedEvents story={this.props.story} />
        </Content>
      </Layout>
    );
  }
}

export default Events;



// WEBPACK FOOTER //
// ./src/events/components/Events/Events.js